import { ArrowDown, ArrowUp, ChevronsUpDown, ChevronDown, ChevronUp } from "lucide-react";
import { cn } from "@/lib/utils"; // Utility for merging class names

export function DataTableColumnHeader({ column, title, className }) {
  if (!column.getCanSort()) {
    return <div className={cn(className)}>{title}</div>;
  }

  const sorted = column.getIsSorted(); // 'asc' | 'desc' | false

  return (
    <button
      onClick={() => column.toggleSorting()}
      className={cn(
        "flex items-center gap-1 hover:text-primary transition-colors",
        className
      )}
    >
      <span>{title}</span>
      {sorted === "desc" ? (
        <ChevronUp className="h-4 w-4" />
      ) : sorted === "asc" ? (
        <ChevronDown className="h-4 w-4" />
      ) : (
        <ChevronsUpDown className="h-4 w-4 text-muted-foreground" />
      )}
    </button>
  );
}
